import { makeStyles } from "tss-react/mui";
import {
  DocumentThumbnail,
  MiDetailFields,
  MiFileInput,
} from "@miplatform/components";
import {
  FONT_WEIGHTS,
  ICONS_WEB,
  TYPOGRAPHY_VARIANTS,
} from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { Box, Typography } from "@mui/material";

function Subtitle({ text }) {
  return (
    <Box display="flex" gap={1} alignItems="center">
      <Typography
        variant={TYPOGRAPHY_VARIANTS.BODY2}
        fontWeight={FONT_WEIGHTS.MEDIUM}
      >
        {text}
      </Typography>
    </Box>
  );
}

export function IssueReviewContent({
  disabled,
  description,
  edit,
  isTask,
  getFields,
  sections,
  issueImages,
  repairImages,
  setShowImagesViewer,
  setImagesInViewer,
  handleAddIssueImage,
  handleAddRepairImage,
  onShowIssueImageViewer,
  onShowRepairImageViewer,
  fullEditMode,
}) {
  const { classes, theme } = useStyles();

  return (
    <>
      {!fullEditMode && (
        <Box className={classes.body}>
          <Subtitle text="Description of Tasks" />
          <Typography variant="caption">{description}</Typography>
        </Box>
      )}
      <Box className={classes.body}>
        <Subtitle
          text={isTask ? "Technicians Details" : sections.DIAGNOSED_ISSUE}
        />
        <Box className={classes.diagnosedIssueSection}>
          {!isTask && (
            <MiDetailFields
              containerStyle={classes.issueDiagnostic}
              detailFields={getFields({
                section: sections.DIAGNOSED_ISSUE,
                disabled,
              })}
              edit={edit}
            />
          )}
          <Box className={classes.uploadSection}>
            <MiFileInput
              disabled={disabled}
              title="Upload Files"
              onChange={handleAddIssueImage}
              style={{ padding: 0, height: 44 }}
              customClassName={classes.uploadButton}
              startIcon={{
                path: mdi[ICONS_WEB.PLUS_CIRCLE],
                iconColor: theme.palette.cyan.dark,
                iconSize: 0.7,
              }}
            />
            <DocumentThumbnail
              document={issueImages[0]}
              documentCount={issueImages.length}
              dimension={40}
              onClick={(e) => {
                e.stopPropagation();
                if (issueImages.length > 0) {
                  setShowImagesViewer(true);
                  setImagesInViewer(issueImages);
                  onShowIssueImageViewer();
                }
              }}
            />
          </Box>
        </Box>
        <MiDetailFields
          detailFields={getFields({
            section: sections.TASK_DESCRIPTION,
            disabled,
          })}
          edit={edit}
        />
      </Box>
      {!isTask && (
        <Box className={classes.body}>
          <Subtitle text={sections.REPAIR_DETAILS} />
          <MiDetailFields
            detailFields={getFields({
              section: sections.REPAIR_DETAILS,
              disabled,
            })}
            edit={edit}
          />
          <Box className={[classes.uploadSection, classes.secondUploadButton]}>
            <MiFileInput
              disabled={disabled}
              title="Upload Files"
              onChange={handleAddRepairImage}
              style={{ padding: 0, height: 44 }}
              customClassName={classes.uploadButton}
              startIcon={{
                path: mdi[ICONS_WEB.PLUS_CIRCLE],
                iconColor: theme.palette.cyan.dark,
                iconSize: 0.7,
              }}
            />
            <DocumentThumbnail
              document={repairImages[0]}
              documentCount={repairImages.length}
              dimension={40}
              onClick={(e) => {
                e.stopPropagation();
                if (repairImages.length > 0) {
                  setShowImagesViewer(true);
                  setImagesInViewer(repairImages);
                  onShowRepairImageViewer();
                }
              }}
            />
          </Box>
        </Box>
      )}
      <Box className={classes.body}>
        <MiDetailFields
          detailFields={getFields({ section: sections.RESOLUTION, disabled })}
          edit={edit}
        />
      </Box>
    </>
  );
}

const useStyles = makeStyles()((theme) => ({
  body: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  uploadSection: {
    display: "flex",
    padding: theme.spacing(1, 0),
    gap: theme.spacing(2),
  },
  diagnosedIssueSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: theme.spacing(2),
  },
  issueDiagnostic: {
    width: "stretch",
  },
  uploadButton: {
    height: 40,
    width: "100%",
    border: `1.5px dashed ${theme.palette.grey.darkAccent}`,
    "&:hover": {
      border: `1.5px dashed ${theme.palette.grey.darkAccent}`,
    },
    color: theme.palette.common.black,
    fontWeight: theme.fontWeight.semiBold,
    fontSize: theme.fontSize.medium,
    backgroundColor: theme.palette.common.white,
  },
  secondUploadButton: {
    alignSelf: "flex-end",
  },
}));
